import React, {useEffect, useState} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import {useAppDispatch} from "../../utils/Hooks";
import {LoggedInView} from "../common/LoggedInView";
import {apiClient} from "../../utils/ApiClient";
import CategoryType from "../../models/CategoryType";
import {VendorContact} from "../../models/VendorContact";
import {Tab} from "../../models/Tab";

const TABS: Tab[] = [
    { identifier: "partial", name: "Grupp 1 (0.1-13,5 LDM)" },
    { identifier: "full", name: "Grupp 2 (13,6 LDM)" },
];

interface RecommendedVendorsScreenProps {
}

export const RecommendedVendorsScreen: React.FC<RecommendedVendorsScreenProps> = () => {

    const {id} = useParams();
    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState<Tab>(TABS[0]);
    const [reverse, setReverse] = useState<boolean>(false);
    const [noMeter, setNoMeter] = useState<boolean>(false);

    const [partialTopLoadings, setPartialTopLoadings] = useState<any[]>([]);
    const [partialRegularLoadings, setPartialRegularLoadings] = useState<any[]>([]);
    const [fullTopLoadings, setFullTopLoadings] = useState<any[]>([]);
    const [fullRegularLoadings, setFullRegularLoadings] = useState<any[]>([]);

    useEffect(() => {
        if (!!id) {
            fetchData();
        }
    }, [id, reverse]);

    const fetchData = async () => {
        try {
            const response = await apiClient.get(`suggest/vendorContact/${id}?reverse=${reverse}`);
            const data = response.data;

            const hasNoMeter = !!data['no_meter'];
            setNoMeter(hasNoMeter);

            setPartialTopLoadings(data['below13_6']['top']);
            setPartialRegularLoadings(data['below13_6']['regular']);

            if (!hasNoMeter) {
                setFullTopLoadings(data['above13_6']['top']);
                setFullRegularLoadings(data['above13_6']['regular']);
            } else {
                setFullTopLoadings([]);
                setFullRegularLoadings([]);
                setActiveTab(TABS[0]);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const [selectedCheckboxes, setSelectedCheckboxes] = useState(() => {
        const storedCheckboxes = sessionStorage.getItem('selectedCheckboxes' + id);
        return storedCheckboxes ? JSON.parse(storedCheckboxes) : {};
    });

    useEffect(() => {
        sessionStorage.setItem('selectedCheckboxes' + id, JSON.stringify(selectedCheckboxes));
    }, [selectedCheckboxes]);

    const handleCheckboxChange = (contactId: number) => {
        setSelectedCheckboxes((prevState: any) => ({
            ...prevState,
            [contactId]: !prevState[contactId]
        }));
    };

    const handleSendEmail = () => {
        const selectedRecommendations = new Map<number, VendorContact>();

        for (const contactId in selectedCheckboxes) {
            if (selectedCheckboxes[contactId]) {
                [...partialTopLoadings, ...partialRegularLoadings, ...fullTopLoadings, ...fullRegularLoadings].forEach((loading) => {
                    loading.contacts.forEach((contact: VendorContact) => {
                        if (contact.id === parseInt(contactId)) {
                            selectedRecommendations.set(contact.id, contact);
                        }
                    });
                });
            }
        }

        const uniqueContacts = Array.from(selectedRecommendations.values());
        sessionStorage.setItem('selectedRecommendations', JSON.stringify(uniqueContacts));

        navigate(`/inquiries/${id}/recommended/send`);
    };

    const handleReverse = () => {
        setReverse(!reverse);
    }

    const regularVendorWidths = {
        name: '25%',
        email: '15%',
        phone: '10%',
        skype: '15%',
        whatsapp: '15%',
        orders: '5%',
        rating: '5%'
    };

    const topVendorWidths = {
        name: '25%',
        email: '15%',
        phone: '10%',
        skype: '15%',
        whatsapp: '15%',
        orders: '5%',
        rating: '5%'
    };

    const handleTabClick = (tab: Tab) => {
        setActiveTab(tab);
    };

    const removeVendorContact = async (contactId: number, startCountryId: number, destinationCountryId: number) => {
        const confirmation = window.confirm("Kas oled kindel, et soovid kontakti soovitustest eemaldada?");
        if (confirmation) {
            await apiClient.post(`vendors/none-important/contacts/${contactId}/toggleRoute?inquiry=${id}&reverse=${reverse}`, {
                start_country_id: startCountryId,
                destination_country_id: destinationCountryId,
            });
            fetchData();
        }
    };

    const renderTabContent = () => {
        if (noMeter) {
            return (
                <div style={{marginBottom: '20px'}}>
                    <h2>Top Kontaktid <small style={{fontSize:'12px'}}>(Vedude arv 2a jooksul)</small></h2><br />
                    <div style={{backgroundColor: '#f5f5f5', padding: '10px', marginBottom: '20px'}}>
                        {partialTopLoadings.map((loading, index) => {
                            if (loading.contacts.length > 0) {
                                return (
                                    <div key={index}>
                                        <h3>{loading.vendor.name} ({loading.total_orders})</h3>
                                        <table className="data">
                                            <thead>
                                            <tr>
                                                <th style={{width: topVendorWidths.name}}>Kontakt</th>
                                                <th style={{width: topVendorWidths.email}}>Email</th>
                                                <th style={{width: topVendorWidths.phone}}>Telefon</th>
                                                <th style={{width: topVendorWidths.skype}}>Teams</th>
                                                <th style={{width: topVendorWidths.whatsapp}}>Whatsapp</th>
                                                <th style={{width: topVendorWidths.orders}}>Vedusid</th>
                                                <th style={{width: topVendorWidths.rating}}>Hinnang</th>
                                                <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {loading.contacts.map((contact: VendorContact, contactIndex: number) => (
                                                <tr key={contactIndex}>
                                                    <td style={{ width: topVendorWidths.name }}>
                                                        <Link to={`/vendors/${contact.vendor_id}/contacts/${contact.id}/modify`}>
                                                            {contact.name}
                                                        </Link>
                                                    </td>
                                                    <td style={{width: topVendorWidths.email}}>
                                                        <a href={`mailto:${contact.emails}`}>{contact.emails}</a>
                                                    </td>
                                                    <td style={{width: topVendorWidths.phone}}>{contact.phone}</td>
                                                    <td style={{ width: topVendorWidths.skype }}>
                                                        {contact.skype && (
                                                            <a href={`skype:${contact.skype}?chat`} target="_blank" rel="noopener noreferrer">
                                                                {contact.skype}
                                                            </a>
                                                        )}
                                                    </td>
                                                    <td style={{ width: topVendorWidths.whatsapp }}>
                                                        {contact.whatsapp && (
                                                            <a href={`https://wa.me/${contact.whatsapp}`} target="_blank" rel="noopener noreferrer">
                                                                {contact.whatsapp}
                                                            </a>
                                                        )}
                                                    </td>
                                                    <td style={{width: topVendorWidths.orders}}>{contact.orders_count}</td>
                                                    <td style={{width: regularVendorWidths.rating}}>
                                                        <Link to={`/vendors/${loading.vendor.id}/contacts/${contact.id}/ratings`}>
                                                            {contact?.rating?.toFixed(2) || '0.00'}
                                                        </Link>
                                                        <a
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                removeVendorContact(
                                                                    contact.id,
                                                                    loading.start_country_id,
                                                                    loading.destination_country_id
                                                                );
                                                            }}
                                                            style={{ color: 'red', textDecoration: 'none', cursor: 'pointer', fontSize: '0.8rem', marginLeft: '10px' }}
                                                        >
                                                            ✖
                                                        </a>
                                                    </td>
                                                    <td style={{width: '50px'}}>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedCheckboxes[contact.id] || false}
                                                            onChange={() => handleCheckboxChange(contact.id)}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                );
                            } else {
                                return null;
                            }
                        })}
                    </div>
                    <h2>Tavakontaktid <small style={{fontSize:'12px'}}>(Vedude arv 4a jooksul)</small></h2>
                    {partialRegularLoadings.map((loading, index) => {
                        if (loading.contacts.length > 0) {
                            return (
                                <div key={index} style={{backgroundColor: '#ffffff'}}>
                                    <h3>{loading.vendor.name} ({loading.total_orders})</h3>
                                    <table className="data">
                                        <thead>
                                        <tr>
                                            <th style={{width: regularVendorWidths.name}}>Kontakt</th>
                                            <th style={{width: regularVendorWidths.email}}>Email</th>
                                            <th style={{width: regularVendorWidths.phone}}>Telefon</th>
                                            <th style={{width: regularVendorWidths.skype}}>Teams</th>
                                            <th style={{width: regularVendorWidths.whatsapp}}>Whatsapp</th>
                                            <th style={{width: regularVendorWidths.orders}}>Vedusid</th>
                                            <th style={{width: regularVendorWidths.rating}}>Hinnang</th>
                                            <th style={{width: '50px'}}></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {loading.contacts.map((contact: VendorContact, contactIndex: number) => (
                                            <tr key={contactIndex}>
                                                <td style={{ width: regularVendorWidths.name }}>
                                                    <Link to={`/vendors/${contact.vendor_id}/contacts/${contact.id}/modify`}>
                                                        {contact.name}
                                                    </Link>
                                                </td>
                                                <td style={{width: regularVendorWidths.email}}>
                                                    <a href={`mailto:${contact.emails}`}>{contact.emails}</a>
                                                </td>
                                                <td style={{width: regularVendorWidths.phone}}>{contact.phone}</td>
                                                <td style={{ width: regularVendorWidths.skype }}>
                                                    {contact.skype && (
                                                        <a href={`skype:${contact.skype}?chat`} target="_blank" rel="noopener noreferrer">
                                                            {contact.skype}
                                                        </a>
                                                    )}
                                                </td>
                                                <td style={{ width: regularVendorWidths.whatsapp }}>
                                                    {contact.whatsapp && (
                                                        <a href={`https://wa.me/${contact.whatsapp}`} target="_blank" rel="noopener noreferrer">
                                                            {contact.whatsapp}
                                                        </a>
                                                    )}
                                                </td>
                                                <td style={{width: regularVendorWidths.orders}}>{contact.orders_count}</td>
                                                <td style={{width: regularVendorWidths.rating}}>
                                                    <Link to={`/vendors/${loading.vendor.id}/contacts/${contact.id}/ratings`}>
                                                        {contact?.rating?.toFixed(2) || '0'}
                                                    </Link>
                                                    <a
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            removeVendorContact(
                                                                contact.id,
                                                                loading?.start_country_id,
                                                                loading?.destination_country_id
                                                            );
                                                        }}
                                                        style={{ color: 'red', textDecoration: 'none', cursor: 'pointer', fontSize: '0.8rem', marginLeft: '10px' }}
                                                    >
                                                        ✖
                                                    </a>
                                                </td>
                                                <td style={{width: '50px'}}>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedCheckboxes[contact.id] || false}
                                                        onChange={() => handleCheckboxChange(contact.id)}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            );
                        } else {
                            return null;
                        }
                    })}
                </div>
            );
        }

        if (activeTab.identifier === "partial") {
            return (
                <div style={{marginBottom: '20px'}}>
                    {!noMeter && <h1>Grupp 1 (0.1-13,5 LDM)</h1>}
                    <h2>Top Kontaktid <small style={{fontSize:'12px'}}>(Vedude arv 2a jooksul)</small></h2>
                    <div style={{backgroundColor: '#f5f5f5', padding: '10px', marginBottom: '20px'}}>
                        {partialTopLoadings.map((loading, index) => {
                            if (loading.contacts.length > 0) {
                                return (
                                    <div key={index}>
                                        <h3>{loading.vendor.name} ({loading.total_orders})</h3>
                                        <table className="data">
                                            <thead>
                                            <tr>
                                                <th style={{width: topVendorWidths.name}}>Kontakt</th>
                                                <th style={{width: topVendorWidths.email}}>Email</th>
                                                <th style={{width: topVendorWidths.phone}}>Telefon</th>
                                                <th style={{width: topVendorWidths.skype}}>Teams</th>
                                                <th style={{width: topVendorWidths.whatsapp}}>Whatsapp</th>
                                                <th style={{width: topVendorWidths.orders}}>Vedusid</th>
                                                <th style={{width: topVendorWidths.rating}}>Hinnang</th>
                                                <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {loading.contacts.map((contact: VendorContact, contactIndex: number) => (
                                                <tr key={contactIndex}>
                                                    <td style={{ width: topVendorWidths.name }}>
                                                        <Link to={`/vendors/${contact.vendor_id}/contacts/${contact.id}/modify`}>
                                                            {contact.name}
                                                        </Link>
                                                    </td>
                                                    <td style={{width: topVendorWidths.email}}><a
                                                        href={`mailto:${contact.emails}`}>{contact.emails}</a></td>
                                                    <td style={{width: topVendorWidths.phone}}>{contact.phone}</td>
                                                    <td style={{ width: topVendorWidths.skype }}>
                                                        <a href={`skype:${contact.skype}?chat`} target="_blank" rel="noopener noreferrer">
                                                            {contact.skype}
                                                        </a>
                                                    </td>
                                                    <td style={{ width: topVendorWidths.whatsapp }}>
                                                        <a href={`https://wa.me/${contact.whatsapp}`} target="_blank" rel="noopener noreferrer">
                                                            {contact.whatsapp}
                                                        </a>
                                                    </td>
                                                    <td style={{width: topVendorWidths.orders}}>{contact.orders_count}</td>
                                                    <td style={{width: regularVendorWidths.rating}}>
                                                        <Link
                                                            to={`/vendors/${loading.vendor.id}/contacts/${contact.id}/ratings`}>{contact?.rating?.toFixed(2) || '0.00'}</Link>
                                                        <a
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                removeVendorContact(
                                                                    contact.id,
                                                                    loading.start_country_id,
                                                                    loading.destination_country_id
                                                                );
                                                            }}
                                                            style={{
                                                                color: 'red',
                                                                textDecoration: 'none',
                                                                cursor: 'pointer',
                                                                fontSize: '0.8rem',
                                                                marginLeft: '10px',
                                                            }}
                                                        >
                                                            ✖
                                                        </a>
                                                    </td>
                                                    <td style={{width: '50px'}}>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedCheckboxes[contact.id] || false}
                                                            onChange={() => handleCheckboxChange(contact.id)}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                );
                            } else {
                                return null;
                            }
                        })}
                    </div>
                    <h2>Tavakontaktid <small style={{fontSize:'12px'}}>(Vedude arv 4a jooksul)</small></h2>
                    {partialRegularLoadings.map((loading, index) => {
                        if (loading.contacts.length > 0) {
                            return (
                                <div key={index} style={{backgroundColor: '#ffffff'}}>
                                    <h3>{loading.vendor.name} ({loading.total_orders})</h3>
                                    <table className="data">
                                        <thead>
                                        <tr>
                                            <th style={{width: regularVendorWidths.name}}>Kontakt</th>
                                            <th style={{width: regularVendorWidths.email}}>Email</th>
                                            <th style={{width: regularVendorWidths.phone}}>Telefon</th>
                                            <th style={{width: regularVendorWidths.skype}}>Teams</th>
                                            <th style={{width: regularVendorWidths.whatsapp}}>Whatsapp</th>
                                            <th style={{width: regularVendorWidths.orders}}>Vedusid</th>
                                            <th style={{width: regularVendorWidths.rating}}>Hinnang</th>
                                            <th style={{width: '50px'}}></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {loading.contacts.map((contact: VendorContact, contactIndex: number) => (
                                            <tr key={contactIndex}>
                                                <td style={{ width: regularVendorWidths.name }}>
                                                    <Link to={`/vendors/${contact.vendor_id}/contacts/${contact.id}/modify`}>
                                                        {contact.name}
                                                    </Link>
                                                </td>
                                                <td style={{width: regularVendorWidths.email}}><a
                                                    href={`mailto:${contact.emails}`}>{contact.emails}</a></td>
                                                <td style={{width: regularVendorWidths.phone}}>{contact.phone}</td>
                                                <td style={{ width: regularVendorWidths.skype }}>
                                                    {contact.skype && (
                                                        <a href={`skype:${contact.skype}?chat`} target="_blank" rel="noopener noreferrer">
                                                            {contact.skype}
                                                        </a>
                                                    )}
                                                </td>
                                                <td style={{ width: regularVendorWidths.whatsapp }}>
                                                    {contact.whatsapp && (
                                                        <a href={`https://wa.me/${contact.whatsapp}`} target="_blank" rel="noopener noreferrer">
                                                            {contact.whatsapp}
                                                        </a>
                                                    )}
                                                </td>
                                                <td style={{width: regularVendorWidths.orders}}>{contact.orders_count}</td>
                                                <td style={{width: regularVendorWidths.rating}}>
                                                    <Link
                                                        to={`/vendors/${loading.vendor.id}/contacts/${contact.id}/ratings`}>{contact?.rating?.toFixed(2) || '0'}</Link>
                                                    <a
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            removeVendorContact(
                                                                contact.id,
                                                                loading?.start_country_id,
                                                                loading?.destination_country_id
                                                            );
                                                        }}
                                                        style={{
                                                            color: 'red',
                                                            textDecoration: 'none',
                                                            cursor: 'pointer',
                                                            fontSize: '0.8rem',
                                                            marginLeft: '10px',
                                                        }}
                                                    >
                                                        ✖
                                                    </a>
                                                </td>
                                                <td style={{width: '50px'}}>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedCheckboxes[contact.id] || false}
                                                        onChange={() => handleCheckboxChange(contact.id)}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            );
                        } else {
                            return null;
                        }
                    })}

                </div>
            );
        } else if (activeTab.identifier === "full") {
            return (
                <div style={{marginBottom: '20px'}}>
                    {!noMeter && <h1>Grupp 2 (13,6 LDM)</h1>}
                    <h2>Top Kontaktid <small style={{fontSize:'12px'}}>(Vedude arv 4a jooksul)</small></h2>
                    <div style={{backgroundColor: '#f5f5f5', padding: '10px', marginBottom: '20px'}}>
                        {fullTopLoadings.map((loading, index) => {
                            if (loading.contacts.length > 0) {
                                return (
                                    <div key={index}>
                                        <h3>{loading.vendor.name} ({loading.total_orders})</h3>
                                        <table className="data">
                                            <thead>
                                            <tr>
                                                <th style={{width: topVendorWidths.name}}>Kontakt</th>
                                                <th style={{width: topVendorWidths.email}}>Email</th>
                                                <th style={{width: topVendorWidths.phone}}>Telefon</th>
                                                <th style={{width: topVendorWidths.skype}}>Teams</th>
                                                <th style={{width: topVendorWidths.whatsapp}}>Whatsapp</th>
                                                <th style={{width: topVendorWidths.orders}}>Vedusid</th>
                                                <th style={{width: topVendorWidths.rating}}>Hinnang</th>
                                                <th></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {loading.contacts.map((contact: VendorContact, contactIndex: number) => (
                                                <tr key={contactIndex}>
                                                    <td style={{ width: topVendorWidths.name }}>
                                                        <Link to={`/vendors/${contact.vendor_id}/contacts/${contact.id}/modify`}>
                                                            {contact.name}
                                                        </Link>
                                                    </td>
                                                    <td style={{width: topVendorWidths.email}}><a
                                                        href={`mailto:${contact.emails}`}>{contact.emails}</a></td>
                                                    <td style={{width: topVendorWidths.phone}}>{contact.phone}</td>
                                                    <td style={{ width: topVendorWidths.skype }}>
                                                        {contact.skype && (
                                                            <a href={`skype:${contact.skype}?chat`} target="_blank" rel="noopener noreferrer">
                                                                {contact.skype}
                                                            </a>
                                                        )}
                                                    </td>
                                                    <td style={{ width: topVendorWidths.whatsapp }}>
                                                        {contact.whatsapp && (
                                                            <a href={`https://wa.me/${contact.whatsapp}`} target="_blank" rel="noopener noreferrer">
                                                                {contact.whatsapp}
                                                            </a>
                                                        )}
                                                    </td>
                                                    <td style={{width: topVendorWidths.orders}}>{contact.orders_count}</td>
                                                    <td style={{width: regularVendorWidths.rating}}>
                                                        <Link
                                                            to={`/vendors/${loading.vendor.id}/contacts/${contact.id}/ratings`}>{contact?.rating?.toFixed(2) || '0'}</Link>
                                                        <a
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                removeVendorContact(
                                                                    contact.id,
                                                                    loading?.start_country_id,
                                                                    loading?.destination_country_id
                                                                );
                                                            }}
                                                            style={{
                                                                color: 'red',
                                                                textDecoration: 'none',
                                                                cursor: 'pointer',
                                                                fontSize: '0.8rem',
                                                                marginLeft: '10px',
                                                            }}
                                                        >
                                                            ✖
                                                        </a>
                                                    </td>
                                                    <td style={{width: '50px'}}>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedCheckboxes[contact.id] || false}
                                                            onChange={() => handleCheckboxChange(contact.id)}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                );
                            } else {
                                return null;
                            }
                        })}
                    </div>
                    <h2>Tavakontaktid <small style={{fontSize:'12px'}}>(Vedude arv 4a jooksul)</small></h2>
                    {fullRegularLoadings.map((loading, index) => {
                        if (loading.contacts.length > 0) {
                            return (
                                <div key={index} style={{backgroundColor: '#ffffff'}}>
                                    <h3>{loading.vendor.name} ({loading.total_orders})</h3>
                                    <table className="data">
                                        <thead>
                                        <tr>
                                            <th style={{width: regularVendorWidths.name}}>Kontakt</th>
                                            <th style={{width: regularVendorWidths.email}}>Email</th>
                                            <th style={{width: regularVendorWidths.phone}}>Telefon</th>
                                            <th style={{width: regularVendorWidths.skype}}>Teams</th>
                                            <th style={{width: regularVendorWidths.whatsapp}}>Whatsapp</th>
                                            <th style={{width: regularVendorWidths.orders}}>Vedusid</th>
                                            <th style={{width: regularVendorWidths.rating}}>Hinnang</th>
                                            <th style={{width: '50px'}}></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {loading.contacts.map((contact: VendorContact, contactIndex: number) => (
                                            <tr key={contactIndex}>
                                                <td style={{ width: regularVendorWidths.name }}>
                                                    <Link to={`/vendors/${contact.vendor_id}/contacts/${contact.id}/modify`}>
                                                        {contact.name}
                                                    </Link>
                                                </td>
                                                <td style={{width: regularVendorWidths.email}}><a
                                                    href={`mailto:${contact.emails}`}>{contact.emails}</a></td>
                                                <td style={{width: regularVendorWidths.phone}}>{contact.phone}</td>
                                                <td style={{ width: regularVendorWidths.skype }}>
                                                    {contact.skype && (
                                                        <a href={`skype:${contact.skype}?chat`} target="_blank" rel="noopener noreferrer">
                                                            {contact.skype}
                                                        </a>
                                                    )}
                                                </td>
                                                <td style={{ width: regularVendorWidths.whatsapp }}>
                                                    {contact.whatsapp && (
                                                        <a href={`https://wa.me/${contact.whatsapp}`} target="_blank" rel="noopener noreferrer">
                                                            {contact.whatsapp}
                                                        </a>
                                                    )}
                                                </td>
                                                <td style={{width: regularVendorWidths.orders}}>{contact.orders_count}</td>
                                                <td style={{width: regularVendorWidths.rating}}>
                                                    <Link
                                                        to={`/vendors/${loading.vendor.id}/contacts/${contact.id}/ratings`}>{contact?.rating?.toFixed(2) || '0'}</Link>
                                                    <a
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            removeVendorContact(
                                                                contact.id,
                                                                loading?.start_country_id,
                                                                loading?.destination_country_id
                                                            );
                                                        }}
                                                        style={{
                                                            color: 'red',
                                                            textDecoration: 'none',
                                                            cursor: 'pointer',
                                                            fontSize: '0.8rem',
                                                            marginLeft: '10px',
                                                        }}
                                                    >
                                                        ✖
                                                    </a>
                                                </td>
                                                <td style={{width: '50px'}}>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedCheckboxes[contact.id] || false}
                                                        onChange={() => handleCheckboxChange(contact.id)}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            );
                        } else {
                            return null;
                        }
                    })}

                </div>
            );
        }
    };

    return (
        <LoggedInView fullWidth={false}>
            {!noMeter && (
                <ul className="tabs clear" style={{width: '100%'}}>
                    {TABS.map(tab => (
                        <li key={tab.identifier} className={activeTab === tab ? "active" : ""}>
                            <a href="Javascript:;" onClick={() => handleTabClick(tab)}>{tab.name}</a>
                        </li>
                    ))}
                </ul>
            )}
            {renderTabContent()}
            <p className="action" style={{display: 'flex', justifyContent: 'space-between'}}>
                <button type="button" onClick={handleReverse}><span><strong>Kontrolli vastupidist</strong></span></button>
                <button type="submit" onClick={handleSendEmail}><span><strong>Saada email</strong></span></button>
            </p>
        </LoggedInView>
    );

}